module.exports = __webpack_public_path__ + "img/model_k750_small.d2bdad2f.png";